import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import PageEditor from "@/pages/admin/PageEditor";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/pages/$id")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-page-editor", path: "/admin/pages/$id", title: "Cloud Admin Page Editor", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><PageEditor /></AdminLayout>,
});
